module.exports = __webpack_public_path__ + "img/oldEstate_weizhi.9829a7ba.png";